module.exports = __webpack_public_path__ + "static/media/uex-logo.5ed3e1ba.png";